exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image-box[data-v-e20a4980]{display:-webkit-box;display:-ms-flexbox;display:flex}\n", ""]);

// exports
